/*<-----------------imports------------------------->*/
import React from "react";
import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
/*<-----------------imports------------------------->*/

/* Creating custom text field */
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "black",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
});

export const SearchBox = ({ handleChange }) => {
  return (
    <div>
      <CssTextField
        sx={{
          marginTop: 10,
          marginBottom: 10,
        }}
        id="standard-search"
        label="Search companies"
        type="search"
        variant="standard"
        onChange={handleChange}
      />
    </div>
  );
};
